import React, { useState, useEffect, useRef } from "react";
import Icon from "../Icon";
import { ActionMenuContainer, ActionIcon, ActionMenuList, List } from "./style";

const ActionMenu = ({ onClick, count }) => {
  const [collapse, setCollapse] = useState(false);
  const menuRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setCollapse(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <ActionMenuContainer ref={menuRef}>
        <ActionIcon
          onClick={() => {
            setCollapse(!collapse);
          }}
        >
          <Icon type="vertical-dots" />
        </ActionIcon>
        {collapse && (
          <ActionMenuList>
            <List>
              <li onClick={() => onClick(true)}>
                View Unaccepted Meetings
                {count && <span>{count}</span>}
              </li>
            </List>
          </ActionMenuList>
        )}
      </ActionMenuContainer>
    </>
  );
};

export default ActionMenu;
